function sendEvent(data: { action: string, [key: string]: string }) {
  // Pass the event through to the wrapper, if it defines a function to receive it
  if (window.eventPassthrough && typeof(window.eventPassthrough) === "function") {
    window.eventPassthrough(data);
  }

  if (!window.parent) {
    return;
  }
  window.parent.postMessage(data, "*");
}

export default class PostMessage {
  static setPage(page: string, userId?: string) {
    sendEvent({ action: "REG_SET_PAGE", page, userId: userId || "" });
  }
  static submitReg() {
    sendEvent({ action: "REG_SUBMIT" });
  }
  static regComplete() {
    sendEvent({ action: "REG_COMPLETE" });
  }
  static regLoaded(mode: string) {
    sendEvent({ action: "REG_LOADED", mode });
  }
  static regError(errorCode: string) {
    sendEvent({ action: "REG_ERROR", errorCode });
  }
  static regEmailCodeValidationSuccess() {
    sendEvent({ action: "REG_EMAIL_CODE_VALIDATION_SUCCESS" });
  }
  static regEmailCodeValidationFailed(errorCode: string) {
    sendEvent({ action: "REG_EMAIL_CODE_VALIDATION_FAILED", errorCode });
  }
}
